import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, Form, Button } from "tabler-react";
import { addBlockUsersToDb, optinManualUpload, optinUpload } from "../../services/client";

function AddBlockedUsers({ onSubmit }) {
    const [mobileNo, setMobileNo] = useState('');
    const handleManualSubmit = async (e) => {
        try {
            e.preventDefault();
            let obj = {
                phoneNumber: mobileNo
            }

            const res = await addBlockUsersToDb(obj);
            if (res) {

                toast.success("Success");
            }
            if (onSubmit) onSubmit();
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Add Blocked Users</Card.Title>
                </Card.Header>
                <Card.Body>

                    <form id="csvForma" onSubmit={handleManualSubmit}>
                        <Form.FieldSet className="col-lg-12">
                            <Form.Group label="" className="upload-cont">
                                <div className="row card-header">
                                    <div className="col-sm-12">
                                        <span className="form-label">Mobile Number</span>
                                        <input id="csv" name="example-text-input" className="form-control" type="text" onChange={(e) => setMobileNo(e.target.value)} />
                                    </div>
                                </div>
                            </Form.Group>
                            <Button color="primary btn-block " className=" btn-block aligncentre" type="submit">
                                Submit
                            </Button>
                        </Form.FieldSet>
                    </form>
                </Card.Body>
                <ToastContainer autoClose={5000} position={"bottom-right"} />
            </Card>

        </>
    );
}
export default withRouter(AddBlockedUsers);
